const DepartmentsTableColumns = [
    {
        id: "name",
        labelEn: "Department Name",
        labelAr: "اسم القسم",
        align: "start",
        width: 200,
    },
    {
        id: "slug",
        labelEn: "Slug",
        labelAr: "الرابط (Slug)",
        align: "center",
        width: 150,
    },
    // {
    //     id: "sort_order",
    //     labelEn: "Sort Order",
    //     labelAr: "الترتيب",
    //     align: "center",
    //     width: 100,
    // },
    {
        id: "status",
        labelEn: "Status",
        labelAr: "الحالة",
        align: "center",
        width: 120,
    },
    {
        id: "created_at",
        labelEn: "Created At",
        labelAr: "تاريخ الإضافة",
        align: "center",
        width: 150,
    },
];

export default DepartmentsTableColumns;
